import React from "react";

const Services = () => {
  // services details
  const services = [
    {
      name: "Software Develop",
      desc: "Providing tailored solutions that meet your specific needs and delivering high-quality, reliable software on time, within budget and on time.",
      icon: "fas fa-code",
    },
    {
      name: "Web Design",
      desc: "Creating a visually appealing, user-friendly website that aligns with your brand and objectives, ensuring a strong online presence and a positive user experience.",
      icon: "fas fa-desktop",
    },
    {
      name: "Database Administration",
      desc: "Optimizing and maintaining your databases to ensure data integrity, availability, and security, thus supporting your business operations and decision-making processes.",
      icon: "fas fa-database",
    },
    {
      name: "App Design & Develop",
      desc: "Crafting a user-friendly, visually appealing, and feature-rich mobile or web application that aligns with your goals and provides a seamless and engaging user experience.",
      icon: "fas fa-rocket",
    },
    {
      name: "Business Analysis",
      desc: "Analyzing your business processes, identifying opportunities for improvement, and providing data-driven insights and recommendations to optimize operations and achieve your strategic objectives.",
      icon: "fas fa-chart-area",
    },
    {
      name: "Technical Support",
      desc: "Resolving your technical issues, offering clear and effective solutions, and providing exceptional customer service to ensure your technology functions seamlessly and to your satisfaction.",
      icon: "fas fa-wrench",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do?</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I can help your next project
        </h2>
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
